import { BehaviorSubject } from 'rxjs';
import { getCurrentEnv, isCaremark, isSpecialty } from '../utils/utils';

// Translation API constants
export const TRANSLATION_EXPERIENCE_ID = '76a35525-1743-4ccd-bdd4-d10aad047e79';

// API Keys
const LOWER_ENV_TRANSLATION_KEY = 'PRX4fYhAfVTr3UH3tSOTlb9oYNrAPUjA';
const PROD_ENV_TRANSLATION_KEY = 'HGNLXaQhG8CtglhHBvA7XD2TFnso1Scx';

// Translation API base paths per LOB
const SPECIALTY_TRANSLATE_API_URI = '/apims/client/experience/v2/load';
const CAREMARK_TRANSLATE_API_URI = '/api/client/experience/v2/load';
const RETAIL_TRANSLATE_API_URI = '/api/client/experience/v2/load';

/**
 * Get translation API key based on environment
 * @returns BehaviorSubject with API key
 */
export const getTranslateApiKey = (): BehaviorSubject<string | null> => {
  const currentEnv = getCurrentEnv();
  const apiKey = currentEnv === 'PROD' ? PROD_ENV_TRANSLATION_KEY : LOWER_ENV_TRANSLATION_KEY;
  return new BehaviorSubject<string | null>(apiKey);
};

/**
 * Get translation API URL based on LOB
 * @returns BehaviorSubject with full API URL
 */
export const getTranslateApiUrl = (): BehaviorSubject<string | null> => {
  let url = '';

  if (isSpecialty()) {
    url = `${SPECIALTY_TRANSLATE_API_URI}/${TRANSLATION_EXPERIENCE_ID}`;
  } else if (isCaremark()) {
    url = `${CAREMARK_TRANSLATE_API_URI}/${TRANSLATION_EXPERIENCE_ID}`;
  } else {
    // Default to retail
    url = `${RETAIL_TRANSLATE_API_URI}/${TRANSLATION_EXPERIENCE_ID}`;
  }

  return new BehaviorSubject<string | null>(url);
};

/**
 * Get preferred language from session storage or cookies
 * @returns Language code ('es' or 'en') or null
 */
export const getPreferredLanguage = (): string | null => {
  if (globalThis.window === undefined) return null;
  try {
    // Check sessionStorage first
    const sessionLang = sessionStorage.getItem('preferred_language');
    if (sessionLang) return sessionLang;

    // Fallback to checking cookies
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
      const [name, value] = cookie.trim().split('=');
      if (name === 'preferred_language') {
        return decodeURIComponent(value);
      }
    }

    return null;
  } catch (error) {
    console.warn('Could not access sessionStorage or cookies for language preference:', error);
    return null;
  }
};
